const images = document.querySelectorAll('body.single-project .clickable-image')
const lightboxEl = document.querySelector('.lightbox')
const imagesWrapper = document.querySelector('.lightbox .images-wrapper')
const closeBtnEl = document.querySelector('.lightbox .close-btn')
const prevBtnEl = document.querySelector('.lightbox .controls .prev')
const nextBtnEl = document.querySelector('.lightbox .controls .next')

if (images && lightboxEl && imagesWrapper) {
	images.forEach((img, index) => {
		// Add images to the DOM
		var imgEl = document.createElement('img')
		const imgSrc = img.getAttribute('src')
		const imgSrcset = img.getAttribute('srcset')
		if (imgSrc) {
			imgEl.setAttribute('src', imgSrc)
		}
		if (imgSrcset) {
			imgEl.setAttribute('srcset', imgSrcset)
		}
		imagesWrapper.appendChild(imgEl)

		// Add event listeners to each clickable image on the page to open the lightbox and show the correct image
		img.addEventListener('click', () => {
			lightboxEl.classList.add('show')
			imagesWrapper
				.querySelector(`img:nth-of-type(${index + 1})`)
				?.classList.add('active')
		})
	})

	// When close button is clicked, close the lightbox
	closeBtnEl?.addEventListener('click', () => {
		close()
	})

	//  When next button is clicked, show the next image
	nextBtnEl?.addEventListener('click', () => {
		next()
	})

	// When prev button is clicked, show the previous image
	prevBtnEl?.addEventListener('click', () => {
		prev()
	})

	// When user clicks somewhere in the lightbox that isn't the controls or the visible image, close the lightbox
	lightboxEl.addEventListener('click', e => {
		if (e.target == imagesWrapper) {
			close()
		}
	})

	function close() {
		lightboxEl?.classList.remove('show')
		lightboxEl?.querySelector('img.active')?.classList.remove('active')
	}

	function next() {
		var currImg = lightboxEl?.querySelector('img.active')
		var nextImg = currImg?.nextElementSibling
		if (nextImg) {
			currImg?.classList.remove('active')
			nextImg?.classList.add('active')
		} else {
			nextImg = lightboxEl?.querySelector('.images-wrapper img:first-of-type')
			currImg?.classList.remove('active')
			nextImg?.classList.add('active')
		}
	}

	function prev() {
		var currImg = lightboxEl?.querySelector('img.active')
		var prevImg = currImg?.previousElementSibling
		if (prevImg) {
			currImg?.classList.remove('active')
			prevImg?.classList.add('active')
		} else {
			prevImg = lightboxEl?.querySelector('.images-wrapper > img:last-of-type')
			console.log(prevImg)
			currImg?.classList.remove('active')
			prevImg?.classList.add('active')
		}
	}
}
